<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M39 14L1 14L1 8C1 6.34314 2.34314 5 4 5L36 5C37.6569 5 39 6.34315 39 8L39 14Z" :stroke="fill" stroke-width="2"/>
    <rect :fill="fill" height="4.5" rx="1.25" stroke="#F9F9F9" stroke-width="2.5" transform="rotate(-180 32.75 5.75)" width="2.5" x="32.75" y="5.75"/>
    <rect :fill="fill" height="4.5" rx="1.25" stroke="#F9F9F9" stroke-width="2.5" transform="rotate(-180 9.75 5.75)" width="2.5" x="9.75" y="5.75"/>
    <rect height="33" rx="2.5" :stroke="fill" stroke-width="3" transform="rotate(-180 38.5 38.5)" width="37" x="38.5" y="38.5"/>
    <circle cx="32" cy="29" :fill="fill" r="2" transform="rotate(-180 32 29)"/>
    <circle cx="32" cy="22" :fill="fill" r="2" transform="rotate(-180 32 22)"/>
    <ellipse cx="26" cy="29" :fill="fill" rx="2" ry="2" transform="rotate(-180 26 29)"/>
    <ellipse cx="26" cy="22" :fill="fill" rx="2" ry="2" transform="rotate(-180 26 22)"/>
    <ellipse cx="20" cy="29" :fill="fill" rx="2" ry="2" transform="rotate(-180 20 29)"/>
    <ellipse cx="20" cy="22" :fill="fill" rx="2" ry="2" transform="rotate(-180 20 22)"/>
    <ellipse cx="14" cy="29" :fill="fill" rx="2" ry="2" transform="rotate(-180 14 29)"/>
    <ellipse cx="8" cy="29" :fill="fill" rx="2" ry="2" transform="rotate(-180 8 29)"/>
  </svg>

</template>

<script>
export default {
  name: 'Calendar',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
